import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background-50 px-4 text-center">
      <span className="font-heading text-7xl font-bold text-primary-200 md:text-9xl">404</span>
      <h1 className="mt-4 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
        页面不存在或已下架
      </h1>
      <p className="mt-3 max-w-md text-sm text-foreground-600">
        你访问的页面可能已被移除或链接有误，回到首页继续浏览双女主韩漫吧。
      </p>
      <div className="mt-7 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          className="cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          返回首页
        </Link>
        <Link
          to="/category"
          className="cursor-pointer whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300"
        >
          浏览分类
        </Link>
      </div>
    </div>
  );
}